import "./calculationSheet.css";
import { useContext } from "react";
import {parse, validateInput, validateInputForPercent } from "../../methods/contentFormatHelpers";
import { ValuationDataContext } from "../../contextProviders/ValuationDataProvider";
import {isNumber} from "chart.js/helpers";

const CalculationSheet = ({ editable, valuationData, setValuationData, calculateSensitivityAnalysis }) => {
  //const { valuationData, setValuationData, calculateSensitivityAnalysis} = useContext(ValuationDataContext);
  
  return (
    <div className="calculation-sheet-wrapper">
      <div
          className="calculation-modal-content"
          onClick={(event) => event.stopPropagation()}
      >
        <table className="calculation-table">
          <thead>
          <tr className="head-row">
            <th></th>
            {[...Array(21)].map((_, headIndex) => (
                <th key={`head-${headIndex}`}>n + {headIndex}</th>
            ))}
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>Wielkość rynku docelowego</td>
            {valuationData.wielkosc_rynku_docelowego.map(
                (elem, index) => (
                    <td
                        key={`wielkosc_rynku_docelowego-${index}`}
                        className="calculation-modal-cell"
                    >
                      {parseFloat(elem)?.toFixed(2)}
                    </td>
                )
            )}
          </tr>
          <tr>
            <td>Penetracja rynku [%]</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`penetracja_rynku-${index}`}
                    id={`penetracja_rynku-${index}`}
                    onBlur={(elem) => {
                      if (isNumber(elem.target.innerText.split('%')[0])) {
                        // formatPercentage(elem);
                        validateInputForPercent(elem.target);
                        let newState = [...valuationData.penetracja_rynku];
                        newState[index] = parse(elem.target.textContent.replace(' %', ''));
                        setValuationData({
                          type: "update",
                          payload: {penetracja_rynku: newState},
                        });
                      }
                    }}
                    className="calculation-modal-cell"
                    contentEditable={editable}
                    suppressContentEditableWarning={true}
                >
                  {valuationData.penetracja_rynku[index] ? valuationData.penetracja_rynku[index].toFixed(2) + ' %' : 0}
                </td>
            ))}
          </tr>
          </tbody>
        </table>
        <br/>
        <table className="calculation-table">
          <thead>
          <tr className="head-row">
            <th></th>
            {[...Array(21)].map((_, headIndex) => (
                <th key={`head-${headIndex}`}>n + {headIndex}</th>
            ))}
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>Nakłady inwestycyjne</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`naklady_inwestycyjne_obliczeniowy-${index}`}
                    id={`naklady_inwestycyjne_obliczeniowy-${index}`}
                    onBlur={(elem) => {
                      if (isNumber(elem.target.innerText)) {
                        let newState = [
                          ...valuationData.naklady_inwestycyjne_obliczeniowy,
                        ];
                        newState[index] = elem.target.textContent;
                        setValuationData({
                          type: "update",
                          payload: {
                            naklady_inwestycyjne_obliczeniowy: newState,
                          },
                        });
                      }
                    }
                    }
                    className="calculation-modal-cell"
                    contentEditable={editable}
                    suppressContentEditableWarning={true}
                >
                  {valuationData.naklady_inwestycyjne_obliczeniowy[index] || "0.00"}
                </td>
            ))}
          </tr>
          <tr>
            <td>Środki trwałe - dodatkowy sprzęt</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`srodki_trwale_dodatkowy_sprzet-${index}`}
                    id={`srodki_trwale_dodatkowy_sprzet-${index}`}
                    onBlur={(elem) => {
                      validateInput(elem.target);
                      if (isNumber(elem.target.innerText)) {
                        let newState = [
                          ...valuationData.srodki_trwale_dodatkowy_sprzet,
                        ];
                        newState[index] = elem.target.textContent;
                        setValuationData({
                          type: "update",
                          payload: {srodki_trwale_dodatkowy_sprzet: newState},
                        });
                      }
                    }}
                    className="calculation-modal-cell"
                    contentEditable={editable}
                    suppressContentEditableWarning={true}
                >
                  {valuationData.srodki_trwale_dodatkowy_sprzet[index] || "0.00"}
                </td>
            ))}
          </tr>
          <tr>
            <td>Stawka amortyzacji [%]</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`stawka_amortyzacji_st-${index}`}
                    className="calculation-modal-cell"
                >
                  {valuationData.stawka_amortyzacji_st || "0.00"}
                </td>
            ))}
          </tr>
          <tr>
            <td>Obliczenia amortyzacji</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`obliczenia_amortyzacji-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.obliczenia_amortyzacji[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          </tbody>
        </table>
        <br/>
        <table className="calculation-table">
          <thead>
          <tr className="head-row">
            <th></th>
            {[...Array(21)].map((_, headIndex) => (
                <th key={`head-${headIndex}`}>n + {headIndex}</th>
            ))}
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>Wartość szacowanej sprzedaży</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`wartosc_szacowanej_sprzedazy-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.wartosc_szacowanej_sprzedazy[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Cena jednostkowa</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`cena_jednostkowa-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.cena_jednostkowa[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Przychody ze sprzedaży</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`przychody_ze_sprzedazy-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.przychody_ze_sprzedazy[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Amortyzacja</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`amortyzacja-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(valuationData.amortyzacja[index])?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Koszty zmienne produkcji</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`koszty_zmienne_produkcji-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.koszty_zmienne_produkcji[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Koszty stałe produkcji</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`koszty_stale_produkcji-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.koszty_stale_produkcji[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Inne koszty</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`inne_koszty-${index}`}
                    id={`inne_koszty-${index}`}
                    className="calculation-modal-cell"
                    contentEditable={editable}
                    onInput={(elem) => {
                      validateInput(elem.target);
                      if (isNumber(elem.target.innerText)) {
                        let newState = [...valuationData.inne_koszty];
                        newState[index] = elem.target.textContent;
                        setValuationData({
                          type: "update",
                          payload: {inne_koszty: newState},
                        });
                      }
                    }}
                ></td>
            ))}
          </tr>
          <tr>
            <td>Koszty całkowite</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`koszty_calkowite-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.koszty_calkowite[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Wynik finansowy brutto</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`wynik_finansowy_brutto-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.wynik_finansowy_brutto[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Podatek dochodowy</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`podatek_dochodowy-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.podatek_dochodowy[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Wynik finansowy netto</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`wynik_finansowy_netto-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.wynik_finansowy_netto[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          </tbody>
        </table>
        <br/>
        <table className="calculation-table">
          <thead>
          <tr className="head-row">
            <th></th>
            {[...Array(21)].map((_, headIndex) => (
                <th key={`head-${headIndex}`}>n + {headIndex}</th>
            ))}
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>Nakłady inwestycyjne</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`naklady_inwestycyjne_2-${index}`}
                    className="calculation-modal-cell"
                >
                  {valuationData.naklady_inwestycyjne_obliczeniowy[index]}
                </td>
            ))}
          </tr>
          <tr>
            <td>Przychody ze sprzedaży</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`przychody_ze_sprzedazy_2-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.przychody_ze_sprzedazy[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Koszty całkowite</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`koszty_calkowite_2-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.koszty_calkowite[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Wynik finansowy brutto</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`wynik_finansowy_brutto_2-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.wynik_finansowy_brutto[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Podatek dochodowy</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`podatek_dochodowy_2-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.podatek_dochodowy[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Wynik finansowy netto</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`wynik_finansowy_netto_2-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.wynik_finansowy_netto[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Wynik finansowy netto przypisany IP</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`wynik_finansowy_netto_przypisany_ip-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.wynik_finansowy_netto_przypisany_ip[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Amortyzacja</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`amortyzacja_2-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(valuationData.amortyzacja[index])?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Przepływy pieniężne netto</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`przeplywy_pieniezne_netto-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.przeplywy_pieniezne_netto[index]
                  ).toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>
              {"Stopa dyskontowa: " + valuationData.stopa_dyskontowa}
            </td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`stopa_dyskontowa_obliczeniowy-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.stopa_dyskontowa_obliczeniowy[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Zaktual. wartość przepływów pieniężnych netto</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`zaktualizowana_wartosc_przeplywow_pienieznych_netto-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData
                          .zaktualizowana_wartosc_przeplywow_pienieznych_netto[
                          index
                          ]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>NPV</td>
            {[...Array(21)].map((_, index) => (
                <td key={`npv-${index}`} className="calculation-modal-cell"
                    style={valuationData.npv[index] > 0 ? {backgroundColor: "green"} : {backgroundColor: "red"}}>
                  {parseFloat(valuationData.npv[index])?.toFixed(2)}
                </td>
            ))}
          </tr>
          </tbody>
        </table>
        <br/>
        <table className="calculation-table">
          <thead>
          <tr className="head-row">
            <th></th>
            {[...Array(21)].map((_, headIndex) => (
                <th key={`head-${headIndex}`}>n + {headIndex}</th>
            ))}
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>NPV</td>
            {[...Array(21)].map((_, index) => (
                <td key={`npv-${index}`} className="calculation-modal-cell">
                  {parseFloat(valuationData.npv[index])?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Przepływy pieniężne netto</td>
            {[...Array(21)].map((_, index) => (
                <td
                    key={`przeplywy_pieniezne_netto-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      valuationData.przeplywy_pieniezne_netto[index]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          </tbody>
        </table>
        <br/>
        <table className="calculation-table">
          <thead>
          <tr className="head-row">
            <th></th>
            {[...Array(9)].map((_, headIndex) => (
                <th key={`head-${headIndex}`}>{-20 + headIndex * 5}%</th>
            ))}
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>Sprzedaż</td>
            {[...Array(9)].map((_, index) => (
                <td
                    key={`analiza-wrazliwosci-sprzedaz-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      calculateSensitivityAnalysis({
                        sale: (0.8 + (0.05 * index)),
                        price: 1,
                        costs: 1,
                        investment: 1
                      }).npv[9]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Cena</td>
            {[...Array(9)].map((_, index) => (
                <td
                    key={`analiza-wrazliwosci-cena-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      calculateSensitivityAnalysis({
                        sale: 1,
                        price: (0.8 + (0.05 * index)),
                        costs: 1,
                        investment: 1
                      }).npv[9]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Koszt</td>
            {[...Array(9)].map((_, index) => (
                <td
                    key={`analiza-wrazliwosci-koszt-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      calculateSensitivityAnalysis({
                        sale: 1,
                        price: 1,
                        costs: (0.8 + (0.05 * index)),
                        investment: 1
                      }).npv[9]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          <tr>
            <td>Nakłady inwestycyjne</td>
            {[...Array(9)].map((_, index) => (
                <td
                    key={`analiza-wrazliwosci-naklady-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      calculateSensitivityAnalysis({
                        sale: 1,
                        price: 1,
                        costs: 1,
                        investment: (0.8 + (0.05 * index))
                      }).npv[9]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          </tbody>
        </table>
        <br/>
        <table className="calculation-table">
          <thead>
          <tr className="head-row">
            <th></th>
            {[...Array(9)].map((_, headIndex) => (
                <th key={`head-${headIndex}`}>{-20 + headIndex * 5}%</th>
            ))}
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>Sprzedaż</td>
            {[...Array(9)].map((_, index) => (
                <td
                    key={`analiza-wrazliwosci-sprzedaz-irr-${index}`}
                    className="calculation-modal-cell"
                >
                  {(parseFloat(
                      calculateSensitivityAnalysis({
                        sale: (0.8 + (0.05 * index)),
                        price: 1,
                        costs: 1,
                        investment: 1
                      }).irr || ''
                  )?.toFixed(2) * 100).toFixed(2) + '%'}
                </td>
            ))}
          </tr>
          <tr>
            <td>Cena</td>
            {[...Array(9)].map((_, index) => (
                <td
                    key={`analiza-wrazliwosci-cena-irr-${index}`}
                    className="calculation-modal-cell"
                >
                  {(parseFloat(
                      calculateSensitivityAnalysis({
                        sale: 1,
                        price: (0.8 + (0.05 * index)),
                        costs: 1,
                        investment: 1
                      }).irr || '0'
                  )?.toFixed(2) * 100).toFixed(2) + '%'}
                </td>
            ))}
          </tr>
          <tr>
            <td>Koszt</td>
            {[...Array(9)].map((_, index) => (
                <td
                    key={`analiza-wrazliwosci-koszt-irr-${index}`}
                    className="calculation-modal-cell"
                >
                  {(parseFloat(
                      calculateSensitivityAnalysis({
                        sale: 1,
                        price: 1,
                        costs: (0.8 + (0.05 * index)),
                        investment: 1
                      }).irr || '0'
                  )?.toFixed(2) * 100).toFixed(2) + '%'}
                </td>
            ))}
          </tr>
          <tr>
            <td>Nakłady inwestycyjne</td>
            {[...Array(9)].map((_, index) => (
                <td
                    key={`analiza-wrazliwosci-naklady-irr-${index}`}
                    className="calculation-modal-cell"
                >
                  {(parseFloat(
                      calculateSensitivityAnalysis({
                        sale: 1,
                        price: 1,
                        costs: 1,
                        investment: (0.8 + (0.05 * index))
                      }).irr || '0'
                  )?.toFixed(2) * 100).toFixed(2) + '%'}
                </td>
            ))}
          </tr>
          </tbody>
        </table>
        <br/>
        <table className="calculation-table">
          <thead>
          <tr className="head-row">
            <th></th>
            {[...Array(9)].map((_, headIndex) => (
                <th key={`head-${headIndex}`}>{2 + 2 * headIndex}%</th>
            ))}
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>NPV</td>
            {[...Array(9)].map((_, index) => (
                <td
                    key={`analiza-wrazliwosci-stopa-dyskontowa-${index}`}
                    className="calculation-modal-cell"
                >
                  {parseFloat(
                      calculateSensitivityAnalysis({
                        sale: 1,
                        price: 1,
                        costs: 1,
                        investment: 1,
                        discountRate: (2 + 2 * index)
                      }).npv[9]
                  )?.toFixed(2)}
                </td>
            ))}
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CalculationSheet;
